import { format } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';

function hasDisplayTimezone(timezone) {
  return typeof timezone === 'string' && timezone.trim().length > 0;
}

/**
 * Whether a slot's start instant falls on the given calendar grid day (`yyyy-MM-dd`)
 * in `timezone`. Calendar cells use local calendar dates; matching on the raw ISO
 * prefix is UTC-based and mis-groups slots near timezone boundaries.
 *
 * When `timezone` is omitted or blank, uses `date-fns` `format` in the **runtime local**
 * zone — the same approach as `getDaysOfTheWeek` in `utils.js` — so slot grouping
 * tracks the calendar grid.
 *
 * @param {{ start: string }} slot - Slot with ISO 8601 `start`
 * @param {string} calendarDayYyyyMmDd - Cell date from the grid, e.g. `2026-01-05`
 * @param {string} [timezone] - IANA zone when provided (e.g. facility or browser zone)
 * @returns {boolean}
 */
export function slotBelongsToCalendarDay(slot, calendarDayYyyyMmDd, timezone) {
  if (!slot?.start || !calendarDayYyyyMmDd) {
    return false;
  }
  const instant = new Date(slot.start);
  if (Number.isNaN(instant.getTime())) {
    return false;
  }
  const localDay = hasDisplayTimezone(timezone)
    ? formatInTimeZone(instant, timezone.trim(), 'yyyy-MM-dd')
    : format(instant, 'yyyy-MM-dd');
  return localDay === calendarDayYyyyMmDd;
}
